function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M228.663 29.121C228.663 29.121 199.113 -1.41141 152.332 0.0508978C105.55 1.5132 65.6616 31.0566 32.6658 54.2047C-0.330119 77.3527 -9.18282 113.31 10.0213 141.372C29.2254 169.435 59.776 157.628 98.6514 175.843C137.527 194.058 144.917 204.409 188.277 199.98C231.636 195.551 264.608 150.225 259.681 101.981C254.754 53.7374 228.663 29.121 228.663 29.121Z",
  fill: "#3558C7",
  fillOpacity: 0.3
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M266.256 3.93359H26.1766C17.9933 3.93359 11.3594 10.5675 11.3594 18.7508V174.731C11.3594 182.915 17.9933 189.548 26.1766 189.548H266.256C274.439 189.548 281.073 182.915 281.073 174.731V18.7508C281.073 10.5675 274.439 3.93359 266.256 3.93359Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M39.5883 3.93359V189.548H26.1766C22.2468 189.548 18.478 187.987 15.6992 185.209C12.9205 182.43 11.3594 178.661 11.3594 174.731V18.7508C11.3594 14.821 12.9205 11.0522 15.6992 8.27346C18.478 5.49469 22.2468 3.93359 26.1766 3.93359H39.5883Z",
  fill: "#0041BE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M39.5883 3.93359V189.548H26.1766C22.2468 189.548 18.478 187.987 15.6992 185.209C12.9205 182.43 11.3594 178.661 11.3594 174.731V18.7508C11.3594 14.821 12.9205 11.0522 15.6992 8.27346C18.478 5.49469 22.2468 3.93359 26.1766 3.93359H39.5883Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M266.256 3.93359H26.1766C17.9933 3.93359 11.3594 10.5675 11.3594 18.7508V174.731C11.3594 182.915 17.9933 189.548 26.1766 189.548H266.256C274.439 189.548 281.073 182.915 281.073 174.731V18.7508C281.073 10.5675 274.439 3.93359 266.256 3.93359Z",
  stroke: "#E4E4E4",
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M105.765 120.651V119.824",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M196.451 120.651V119.824",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M110.229 120.655V87.5391",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M110.229 116.516H112.498",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M110.229 112.375H112.498",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M110.229 108.23H112.498",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M110.229 104.09H112.498",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M110.229 99.957H112.498",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M110.229 95.8125H112.498",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M110.229 91.6797H112.498",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M110.229 87.5391H112.498",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M187.099 95.8125H182.074V120.652H187.099V95.8125Z",
  fill: "#263238"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M181.523 114.445H176.499V120.655H181.523V114.445Z",
  fill: "#FDB600"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M175.947 113.203H170.922V120.653H175.947V113.203Z",
  fill: "#263238"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M170.362 99.957H165.337V120.663H170.362V99.957Z",
  fill: "#FDB600"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M164.786 108.23H159.761V120.65H164.786V108.23Z",
  fill: "#263238"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M159.201 110.309H154.176V120.652H159.201V110.309Z",
  fill: "#FDB600"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M153.616 112.375H148.591V120.652H153.616V112.375Z",
  fill: "#263238"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M148.04 91.6797H143.015V120.662H148.04V91.6797Z",
  fill: "#FDB600"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M142.464 116.516H137.439V120.659H142.464V116.516Z",
  fill: "#263238"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M136.878 108.23H131.854V120.65H136.878V108.23Z",
  fill: "#FDB600"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M131.303 100.066H126.278V120.772H131.303V100.066Z",
  fill: "#263238"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M125.718 104.09H120.693V120.652H125.718V104.09Z",
  fill: "#FDB600"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M120.142 112.375H115.117V120.652H120.142V112.375Z",
  fill: "#263238"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M105.765 120.652H196.451",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M98.8112 20.9102C98.9572 20.9102 99.1017 20.9389 99.2366 20.9948C99.3714 21.0506 99.494 21.1325 99.5972 21.2357C99.7004 21.3389 99.7823 21.4615 99.8381 21.5963C99.894 21.7312 99.9227 21.8757 99.9227 22.0217C99.9227 22.1677 99.894 22.3122 99.8381 22.447C99.7823 22.5819 99.7004 22.7044 99.5972 22.8076C99.494 22.9109 99.3714 22.9927 99.2366 23.0486C99.1017 23.1044 98.9572 23.1332 98.8112 23.1332C98.5172 23.1308 98.2358 23.0129 98.0279 22.805C97.82 22.5971 97.7021 22.3157 97.6997 22.0217C97.6997 21.7269 97.8168 21.4442 98.0253 21.2357C98.2337 21.0273 98.5164 20.9102 98.8112 20.9102Z",
  fill: "white",
  stroke: "#0041BE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M57.979 68.832H177.353",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M57.979 68.836V67.6602",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M64.2622 68.836V67.6602",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M70.5361 68.836V67.6602",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M76.8198 68.836V67.6602",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M83.103 68.836V67.6602",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M89.3862 68.836V67.6602",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M95.6694 68.836V67.6602",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M101.953 68.836V67.6602",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M108.236 68.836V67.6602",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M114.52 68.836V67.6602",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M120.803 68.836V67.6602",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M127.086 68.836V67.6602",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M133.37 68.836V67.6602",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M139.653 68.836V67.6602",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M145.936 68.836V67.6602",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M152.22 68.836V67.6602",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M158.502 68.836V67.6602",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M164.786 68.836V67.6602",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M171.069 68.836V67.6602",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M177.353 68.836V67.6602",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M57.979 68.8334V22.0117",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M57.979 59.4727H60.9645",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M57.979 50.1055H60.9645",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M57.979 40.7422H60.9645",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M57.979 31.375H60.9645",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M57.979 22.0117H60.9645",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M67.4039 31.375L61.1206 59.4754",
  stroke: "#E4E4E4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M73.6871 47.2946L67.4038 31.375",
  stroke: "#E4E4E4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M79.9708 40.7422L73.6875 47.2919",
  stroke: "#E4E4E4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M86.254 57.5987L79.9707 40.7422",
  stroke: "#E4E4E4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M92.528 31.375L86.2539 57.6014",
  stroke: "#E4E4E4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M98.8111 22.0117L92.5278 31.3724",
  stroke: "#E4E4E4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M105.094 64.1485L98.811 22.0117",
  stroke: "#E4E4E4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M111.378 61.3359L105.095 64.1469",
  stroke: "#E4E4E4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M117.661 60.3984L111.378 61.3354",
  stroke: "#E4E4E4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M123.944 57.6016L117.661 60.4033",
  stroke: "#E4E4E4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M130.228 53.8516L123.944 57.5995",
  stroke: "#E4E4E4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M136.511 55.7255L130.228 53.8516",
  stroke: "#E4E4E4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M142.795 59.4706L136.511 55.7227",
  stroke: "#E4E4E4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M149.078 39.8047L142.794 59.4722",
  stroke: "#E4E4E4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M155.361 36.9922L149.078 39.8032",
  stroke: "#E4E4E4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M161.644 33.2461L155.361 36.994",
  stroke: "#E4E4E4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M167.928 36.994L161.645 33.2461",
  stroke: "#E4E4E4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M174.202 40.7401L167.928 36.9922",
  stroke: "#939AA3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M61.1205 58.3633C61.268 58.3633 61.414 58.3926 61.5501 58.4496C61.6862 58.5066 61.8095 58.5901 61.913 58.6953C62.0165 58.8005 62.0979 58.9252 62.1527 59.0622C62.2075 59.1991 62.2344 59.3457 62.232 59.4932C62.2296 59.7864 62.1114 60.0667 61.9032 60.2732C61.695 60.4797 61.4137 60.5955 61.1205 60.5955C60.8273 60.5955 60.5459 60.4797 60.3377 60.2732C60.1295 60.0667 60.0114 59.7864 60.0089 59.4932C60.0065 59.3457 60.0335 59.1991 60.0882 59.0622C60.143 58.9252 60.2245 58.8005 60.3279 58.6953C60.4314 58.5901 60.5548 58.5066 60.6908 58.4496C60.8269 58.3926 60.9729 58.3633 61.1205 58.3633Z",
  fill: "white",
  stroke: "#0041BE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M67.404 30.2617C67.55 30.2617 67.6945 30.2905 67.8294 30.3463C67.9642 30.4022 68.0867 30.4841 68.19 30.5873C68.2932 30.6905 68.3751 30.813 68.4309 30.9479C68.4868 31.0827 68.5155 31.2273 68.5155 31.3732C68.5155 31.5192 68.4868 31.6637 68.4309 31.7986C68.3751 31.9335 68.2932 32.056 68.19 32.1592C68.0867 32.2624 67.9642 32.3443 67.8294 32.4002C67.6945 32.456 67.55 32.4848 67.404 32.4848C67.258 32.4848 67.1135 32.456 66.9786 32.4002C66.8438 32.3443 66.7213 32.2624 66.618 32.1592C66.5148 32.056 66.4329 31.9335 66.3771 31.7986C66.3212 31.6637 66.2925 31.5192 66.2925 31.3732C66.2925 31.0785 66.4096 30.7957 66.618 30.5873C66.8265 30.3788 67.1092 30.2617 67.404 30.2617Z",
  fill: "white",
  stroke: "#0041BE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M73.6872 46.1797C73.8332 46.1797 73.9777 46.2084 74.1126 46.2643C74.2474 46.3202 74.37 46.402 74.4732 46.5052C74.5764 46.6085 74.6583 46.731 74.7141 46.8659C74.77 47.0007 74.7987 47.1452 74.7987 47.2912C74.7987 47.586 74.6816 47.8687 74.4732 48.0772C74.2647 48.2856 73.982 48.4027 73.6872 48.4027C73.3924 48.4027 73.1097 48.2856 72.9012 48.0772C72.6928 47.8687 72.5757 47.586 72.5757 47.2912C72.5757 47.1452 72.6044 47.0007 72.6603 46.8659C72.7161 46.731 72.798 46.6085 72.9012 46.5052C73.0045 46.402 73.127 46.3202 73.2618 46.2643C73.3967 46.2084 73.5412 46.1797 73.6872 46.1797Z",
  fill: "white",
  stroke: "#0041BE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M79.9704 39.6289C80.2636 39.6289 80.545 39.7448 80.7531 39.9512C80.9613 40.1577 81.0795 40.4381 81.0819 40.7313C81.0819 41.0261 80.9648 41.3088 80.7564 41.5172C80.5479 41.7257 80.2652 41.8428 79.9704 41.8428C79.6756 41.8428 79.3929 41.7257 79.1844 41.5172C78.976 41.3088 78.8589 41.0261 78.8589 40.7313C78.8589 40.5857 78.8877 40.4416 78.9437 40.3073C78.9996 40.1729 79.0817 40.051 79.185 39.9485C79.2883 39.8461 79.4109 39.7651 79.5457 39.7102C79.6805 39.6553 79.8249 39.6277 79.9704 39.6289Z",
  fill: "white",
  stroke: "#0041BE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M86.2541 56.4883C86.5489 56.4883 86.8316 56.6054 87.0401 56.8138C87.2485 57.0223 87.3656 57.305 87.3656 57.5998C87.3632 57.893 87.245 58.1734 87.0368 58.3798C86.8286 58.5863 86.5473 58.7022 86.2541 58.7021C85.9609 58.7022 85.6796 58.5863 85.4714 58.3798C85.2632 58.1734 85.145 57.893 85.1426 57.5998C85.1426 57.305 85.2597 57.0223 85.4681 56.8138C85.6766 56.6054 85.9593 56.4883 86.2541 56.4883Z",
  fill: "white",
  stroke: "#0041BE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M92.5461 30.2617C92.8409 30.2617 93.1236 30.3788 93.3321 30.5873C93.5405 30.7957 93.6576 31.0785 93.6576 31.3732C93.6576 31.5192 93.6289 31.6637 93.573 31.7986C93.5171 31.9335 93.4353 32.056 93.3321 32.1592C93.2288 32.2624 93.1063 32.3443 92.9715 32.4002C92.8366 32.456 92.6921 32.4848 92.5461 32.4848C92.4001 32.4848 92.2556 32.456 92.1207 32.4002C91.9859 32.3443 91.8633 32.2624 91.7601 32.1592C91.6569 32.056 91.575 31.9335 91.5192 31.7986C91.4633 31.6637 91.4346 31.5192 91.4346 31.3732C91.4346 31.0785 91.5517 30.7957 91.7601 30.5873C91.9686 30.3788 92.2513 30.2617 92.5461 30.2617Z",
  fill: "white",
  stroke: "#0041BE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M105.094 63.0352C105.389 63.0352 105.672 63.1523 105.88 63.3607C106.089 63.5692 106.206 63.8519 106.206 64.1467C106.206 64.4415 106.089 64.7242 105.88 64.9326C105.672 65.1411 105.389 65.2582 105.094 65.2582C104.948 65.2582 104.804 65.2294 104.669 65.1736C104.534 65.1177 104.412 65.0359 104.308 64.9326C104.205 64.8294 104.123 64.7069 104.068 64.572C104.012 64.4372 103.983 64.2927 103.983 64.1467C103.983 64.0007 104.012 63.8562 104.068 63.7213C104.123 63.5865 104.205 63.4639 104.308 63.3607C104.412 63.2575 104.534 63.1756 104.669 63.1198C104.804 63.0639 104.948 63.0352 105.094 63.0352Z",
  fill: "white",
  stroke: "#0041BE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M111.378 60.2344C111.523 60.2332 111.667 60.2608 111.802 60.3157C111.937 60.3705 112.06 60.4515 112.163 60.554C112.266 60.6565 112.348 60.7784 112.404 60.9128C112.46 61.0471 112.489 61.1912 112.489 61.3367C112.489 61.6315 112.372 61.9143 112.164 62.1227C111.955 62.3312 111.672 62.4483 111.378 62.4483C111.083 62.4483 110.8 62.3312 110.592 62.1227C110.383 61.9143 110.266 61.6315 110.266 61.3367C110.269 61.0435 110.387 60.7632 110.595 60.5567C110.803 60.3503 111.084 60.2344 111.378 60.2344Z",
  fill: "white",
  stroke: "#0041BE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M117.661 59.2969C117.807 59.2957 117.951 59.3233 118.086 59.3782C118.221 59.433 118.343 59.514 118.447 59.6165C118.55 59.719 118.632 59.8409 118.688 59.9753C118.744 60.1096 118.773 60.2537 118.773 60.3993C118.773 60.5452 118.744 60.6898 118.688 60.8246C118.632 60.9595 118.551 61.082 118.447 61.1852C118.344 61.2884 118.222 61.3703 118.087 61.4262C117.952 61.482 117.807 61.5108 117.661 61.5108C117.367 61.5108 117.084 61.3937 116.875 61.1852C116.667 60.9768 116.55 60.6941 116.55 60.3993C116.552 60.1061 116.67 59.8257 116.879 59.6192C117.087 59.4128 117.368 59.2969 117.661 59.2969Z",
  fill: "white",
  stroke: "#0041BE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M123.945 56.4883C124.239 56.4883 124.522 56.6054 124.73 56.8138C124.939 57.0223 125.056 57.305 125.056 57.5998C125.054 57.893 124.935 58.1734 124.727 58.3798C124.519 58.5863 124.238 58.7022 123.945 58.7021C123.651 58.7022 123.37 58.5863 123.162 58.3798C122.954 58.1734 122.835 57.893 122.833 57.5998C122.833 57.4538 122.862 57.3093 122.918 57.1745C122.973 57.0396 123.055 56.9171 123.159 56.8138C123.262 56.7106 123.384 56.6288 123.519 56.5729C123.654 56.517 123.799 56.4883 123.945 56.4883Z",
  fill: "white",
  stroke: "#0041BE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M130.228 52.7383C130.523 52.7383 130.805 52.8554 131.014 53.0638C131.222 53.2723 131.339 53.555 131.339 53.8498C131.337 54.143 131.219 54.4234 131.01 54.6298C130.802 54.8363 130.521 54.9522 130.228 54.9521C129.935 54.9522 129.653 54.8363 129.445 54.6298C129.237 54.4234 129.119 54.143 129.116 53.8498C129.116 53.555 129.233 53.2723 129.442 53.0638C129.65 52.8554 129.933 52.7383 130.228 52.7383Z",
  fill: "white",
  stroke: "#0041BE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M136.548 54.6133C136.843 54.6133 137.126 54.7304 137.334 54.9388C137.542 55.1473 137.66 55.43 137.66 55.7248C137.657 56.018 137.539 56.2984 137.331 56.5048C137.123 56.7113 136.841 56.8272 136.548 56.8271C136.255 56.8272 135.974 56.7113 135.765 56.5048C135.557 56.2984 135.439 56.018 135.437 55.7248C135.437 55.5788 135.465 55.4343 135.521 55.2994C135.577 55.1646 135.659 55.0421 135.762 54.9388C135.865 54.8356 135.988 54.7537 136.123 54.6979C136.258 54.642 136.402 54.6133 136.548 54.6133Z",
  fill: "white",
  stroke: "#0041BE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M142.795 58.3633C142.941 58.3645 143.086 58.3947 143.221 58.4523C143.356 58.5098 143.479 58.5935 143.581 58.6986C143.684 58.8036 143.764 58.9279 143.818 59.0643C143.873 59.2007 143.899 59.3464 143.897 59.4932C143.894 59.7864 143.776 60.0667 143.568 60.2732C143.36 60.4797 143.079 60.5955 142.785 60.5955C142.492 60.5955 142.211 60.4797 142.003 60.2732C141.794 60.0667 141.676 59.7864 141.674 59.4932C141.674 59.1984 141.791 58.9157 141.999 58.7072C142.208 58.4987 142.491 58.3816 142.785 58.3816L142.795 58.3633Z",
  fill: "white",
  stroke: "#0041BE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M149.078 38.6836C149.373 38.6836 149.655 38.8007 149.864 39.0092C150.072 39.2176 150.189 39.5003 150.189 39.7951C150.189 40.0899 150.072 40.3726 149.864 40.5811C149.655 40.7895 149.373 40.9066 149.078 40.9066C148.783 40.9066 148.5 40.7895 148.292 40.5811C148.083 40.3726 147.966 40.0899 147.966 39.7951C147.966 39.5003 148.083 39.2176 148.292 39.0092C148.5 38.8007 148.783 38.6836 149.078 38.6836Z",
  fill: "white",
  stroke: "#0041BE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M155.361 35.8828C155.656 35.8828 155.939 35.9999 156.147 36.2084C156.355 36.4168 156.473 36.6995 156.473 36.9943C156.473 37.2891 156.355 37.5718 156.147 37.7803C155.939 37.9887 155.656 38.1059 155.361 38.1059C155.066 38.1059 154.784 37.9887 154.575 37.7803C154.367 37.5718 154.25 37.2891 154.25 36.9943C154.25 36.6995 154.367 36.4168 154.575 36.2084C154.784 35.9999 155.066 35.8828 155.361 35.8828Z",
  fill: "white",
  stroke: "#0041BE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M161.644 32.1328C161.79 32.1328 161.935 32.1616 162.07 32.2174C162.204 32.2733 162.327 32.3552 162.43 32.4584C162.533 32.5616 162.615 32.6841 162.671 32.819C162.727 32.9538 162.756 33.0984 162.756 33.2443C162.753 33.5384 162.635 33.8197 162.428 34.0276C162.22 34.2356 161.938 34.3535 161.644 34.3559C161.349 34.3559 161.067 34.2387 160.858 34.0303C160.65 33.8218 160.533 33.5391 160.533 33.2443C160.533 33.0984 160.561 32.9538 160.617 32.819C160.673 32.6841 160.755 32.5616 160.858 32.4584C160.961 32.3552 161.084 32.2733 161.219 32.2174C161.354 32.1616 161.498 32.1328 161.644 32.1328Z",
  fill: "white",
  stroke: "#0041BE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M167.927 35.8828C168.222 35.8828 168.505 35.9999 168.713 36.2084C168.922 36.4168 169.039 36.6995 169.039 36.9943C169.037 37.2884 168.919 37.5697 168.711 37.7776C168.503 37.9856 168.221 38.1035 167.927 38.1059C167.633 38.1059 167.35 37.9887 167.141 37.7803C166.933 37.5718 166.816 37.2891 166.816 36.9943C166.816 36.6995 166.933 36.4168 167.141 36.2084C167.35 35.9999 167.633 35.8828 167.927 35.8828Z",
  fill: "white",
  stroke: "#0041BE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M174.211 39.6289C174.506 39.6289 174.789 39.746 174.997 39.9545C175.206 40.1629 175.323 40.4456 175.323 40.7404C175.323 41.0352 175.206 41.3179 174.997 41.5264C174.789 41.7348 174.506 41.8519 174.211 41.8519C173.919 41.8472 173.64 41.7282 173.434 41.5205C173.228 41.3129 173.111 41.0329 173.109 40.7404C173.109 40.4472 173.225 40.1659 173.431 39.9577C173.638 39.7495 173.918 39.6313 174.211 39.6289Z",
  fill: "white",
  stroke: "#0041BE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M204.737 153.904C204.737 150.378 201.878 147.52 198.352 147.52H131.34H64.3268C60.8008 147.52 57.9424 150.378 57.9424 153.904V172.249C57.9424 175.775 60.8008 178.633 64.3268 178.633H198.352C201.878 178.633 204.737 175.775 204.737 172.249V153.904Z",
  fill: "#E4E4E4"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M271.694 19.8906H225.313V21.7462H271.694V19.8906Z",
  fill: "#C4C4C4"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M271.694 26.6172H225.313V28.4728H271.694V26.6172Z",
  fill: "#C4C4C4"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M271.694 33.3398H225.313V35.1954H271.694V33.3398Z",
  fill: "#C4C4C4"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M271.694 40.0547H225.313V41.9103H271.694V40.0547Z",
  fill: "#C4C4C4"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M271.694 46.7773H225.313V48.6329H271.694V46.7773Z",
  fill: "#C4C4C4"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M271.694 86.2227H225.313V88.0782H271.694V86.2227Z",
  fill: "#C4C4C4"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M271.694 92.9453H225.313V94.8009H271.694V92.9453Z",
  fill: "#C4C4C4"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M271.694 99.6719H225.313V101.527H271.694V99.6719Z",
  fill: "#C4C4C4"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M271.694 106.395H225.313V108.25H271.694V106.395Z",
  fill: "#C4C4C4"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M271.694 113.121H225.313V114.977H271.694V113.121Z",
  fill: "#C4C4C4"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M271.694 150.848H225.313V152.703H271.694V150.848Z",
  fill: "#C4C4C4"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M271.694 157.57H225.313V159.426H271.694V157.57Z",
  fill: "#C4C4C4"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M271.694 164.297H225.313V166.152H271.694V164.297Z",
  fill: "#C4C4C4"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M271.694 171.02H225.313V172.875H271.694V171.02Z",
  fill: "#C4C4C4"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M271.694 177.746H225.313V179.602H271.694V177.746Z",
  fill: "#C4C4C4"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M271.694 19.8906H225.313V21.7462H271.694V19.8906Z",
  fill: "white"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M271.694 26.6172H225.313V28.4728H271.694V26.6172Z",
  fill: "white"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M271.694 33.3398H225.313V35.1954H271.694V33.3398Z",
  fill: "white"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M271.694 40.0547H225.313V41.9103H271.694V40.0547Z",
  fill: "white"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M271.694 46.7773H225.313V48.6329H271.694V46.7773Z",
  fill: "white"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M271.694 86.2227H225.313V88.0782H271.694V86.2227Z",
  fill: "white"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M271.694 92.9453H225.313V94.8009H271.694V92.9453Z",
  fill: "white"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M271.694 99.6719H225.313V101.527H271.694V99.6719Z",
  fill: "white"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M271.694 106.395H225.313V108.25H271.694V106.395Z",
  fill: "white"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M271.694 113.121H225.313V114.977H271.694V113.121Z",
  fill: "white"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M271.694 150.848H225.313V152.703H271.694V150.848Z",
  fill: "white"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M271.694 157.57H225.313V159.426H271.694V157.57Z",
  fill: "white"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M271.694 164.297H225.313V166.152H271.694V164.297Z",
  fill: "white"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M271.694 171.02H225.313V172.875H271.694V171.02Z",
  fill: "white"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M271.694 177.746H225.313V179.602H271.694V177.746Z",
  fill: "white"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  d: "M201.292 155.238H61.9106V157.094H201.292V155.238Z",
  fill: "white"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  d: "M201.292 162.211H61.9106V164.067H201.292V162.211Z",
  fill: "white"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  d: "M201.292 169.191H61.9106V171.047H201.292V169.191Z",
  fill: "white"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M72.144 105.514L61.2217 115.71C59.8823 114.275 58.8388 112.59 58.1509 110.751C57.4629 108.912 57.1439 106.956 57.2122 104.994C57.2804 103.032 57.7345 101.103 58.5486 99.3162C59.3627 97.5297 60.5207 95.9211 61.9566 94.5823C64.6949 91.9547 68.3586 90.5124 72.1532 90.568L72.144 105.514Z",
  fill: "#263238"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  d: "M72.144 105.514L85.5833 98.9922C87.1186 102.208 87.4551 105.866 86.5322 109.308C85.6094 112.75 83.4878 115.75 80.5496 117.766C77.6114 119.782 74.0498 120.683 70.5063 120.307C66.9627 119.93 63.6702 118.3 61.2217 115.711L72.144 105.514Z",
  fill: "#0041BE"
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  d: "M72.144 105.512V90.5575C74.9618 90.5024 77.7345 91.271 80.1218 92.7689C82.509 94.2669 84.4072 96.4291 85.5833 98.9903L72.144 105.512Z",
  fill: "#FDB600"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  d: "M72.144 105.514L61.2217 115.71C59.8823 114.275 58.8388 112.59 58.1509 110.751C57.4629 108.912 57.1439 106.956 57.2122 104.994C57.2804 103.032 57.7345 101.103 58.5486 99.3162C59.3627 97.5297 60.5207 95.9211 61.9566 94.5823C64.6949 91.9547 68.3586 90.5124 72.1532 90.568L72.144 105.514Z",
  fill: "#C4C4C4"
});

function SvgFallback({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 201,
    viewBox: "0 0 282 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFallback);
export default __webpack_public_path__ + "static/media/fallback.200c893f.svg";
export { ForwardRef as ReactComponent };